import { render, staticRenderFns } from "./EmailComponent.vue?vue&type=template&id=1f2edee0&scoped=true"
import script from "./EmailComponent.vue?vue&type=script&lang=js"
export * from "./EmailComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2edee0",
  null
  
)

export default component.exports